/**
 * issue #67 Phase A: 自動保存 ON/OFF を localStorage に永続化する util。
 *
 * - default ON (key 未設定で true)
 * - 'true' / 'false' 以外の値は破損として扱い default true で復帰
 * - localStorage 不可 (private browsing 等) でも throw せず default true
 *
 * 永続化 key: `omakase-unshi:auto-save-enabled` (CLAUDE.md 永続化命名規約準拠)。
 */
const KEY = 'omakase-unshi:auto-save-enabled';

export function getAutoSaveEnabled(): boolean {
  try {
    const v = localStorage.getItem(KEY);
    if (v === null) return true; // default ON
    if (v === 'true') return true;
    if (v === 'false') return false;
    return true; // 破損値は default に fallback
  } catch {
    return true;
  }
}

export function setAutoSaveEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(KEY, String(enabled));
  } catch {
    // ignore (quota / private browsing)
  }
}
